const buildInfo = {
  "packageVersion": "0.1.0",
  "releaseId": "20261103-intervention-revision-r1",
  "buildTarget": "production",
  "builtAt": "2026-11-03T17:54:43.338Z",
  "gitCommit": "6ec0feb0d0fdb906d1a33fc1e819ef4d8c810d9a",
  "gitShort": "6ec0feb0",
  "gitDirty": false,
  "publicReleaseLabel": "Release 20261103-intervention-revision-r1",
  "publicReleaseDateEn": "3rd November 2026",
  "publicReleaseDateFr": "3 novembre 2026",
  "displayLabel": "release 20261103-intervention-revision-r1 | 6ec0feb0"
};

export default buildInfo;
